import { ToastContainer, cssTransition } from "react-toastify/unstyled"

import { OverlayProvider } from "../shareact/context/overlay"
import React from "react"

const WrapPageDefault = ({ children }) => {
    const fadeFromRightOrTop = cssTransition({
        enter: "slideIn",
        exit: "slideOut",
    })

    return (
        <OverlayProvider>
            {children}
            <ToastContainer
                autoClose={false}
                hideProgressBar
                transition={fadeFromRightOrTop}
                theme="colored"
                icon={false}
                closeOnClick
            />
        </OverlayProvider>
    )
}

export default WrapPageDefault
